var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "url(#paint0_linear_6124_7104)",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42543 10.7039C6.34733 10.837 6.38973 11.0083 6.52287 11.0864L13.2069 15.0349C13.3401 15.113 13.5113 15.0706 13.5894 14.9375L14.0431 14.1692C14.114 14.0532 14.0982 13.8856 14.0109 13.7819L12.6861 12.2185C12.6715 12.2029 12.6657 12.1558 12.6745 12.1363L14.0763 9.1716C14.0851 9.15211 14.1234 9.12973 14.1436 9.1304L15.1442 9.17291C15.2716 9.17985 15.4166 9.09974 15.4807 8.99096L15.8438 8.37788C15.9219 8.24475 15.8795 8.07349 15.7464 7.99539L11.4711 5.46663C11.338 5.38853 11.1667 5.43093 11.0886 5.56407L10.7255 6.17714C10.6594 6.28624 10.6605 6.45032 10.7267 6.55955L11.2451 7.41516C11.2561 7.43337 11.2535 7.47788 11.2421 7.49378L9.32079 10.152C9.30778 10.1701 9.26456 10.1873 9.24377 10.1827L7.23529 9.77638C7.10081 9.75059 6.94772 9.81803 6.87905 9.93558L6.42543 10.7039ZM7.36853 16.0324L8.98972 13.2918L10.0863 13.9374L8.46544 16.68C8.44038 16.7222 8.40656 16.7599 8.36689 16.7865L7.33078 17.497C7.27161 17.5389 7.19368 17.4917 7.19992 17.4206L7.32324 16.1701C7.32913 16.1211 7.34347 16.0746 7.36853 16.0324Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6124_7104",
    x1: 11,
    y1: 2,
    x2: 11,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0017E1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionIcon);
export default __webpack_public_path__ + "static/media/union_icon.f05e7b99c415b635ebfa1cf21dd72ea9.svg";
export { ForwardRef as ReactComponent };